import { Card, Col, Row } from 'antd';
import React from 'react';
import { Navigate } from "react-router-dom";
import PageTitle from "../page-header/PageHeader";

import AddLeave from "./AddLeave";
import LeaveAllocation from './leaveAllocation';

const Leave = (props) => {
	const isLogged = Boolean(localStorage.getItem("isLogged"));

	if (!isLogged) {
		return <Navigate to={"/admin/auth/login"} replace={true} />;
	}
	return (
		
		<>
	<PageTitle title='Back' />
    <Row gutter={16}>
      <Col span={8}>
        <Card title="Application for Leave">
          <AddLeave />
        </Card>
      </Col>
      <Col span={16}>
        <Card title="Leave Allocation">
          <LeaveAllocation />
        </Card>
      </Col>
    </Row>
	</>
	);
};

export default Leave;
